import TypographyPrimary from 'components/Typography/Primary'
import { StyledBody, StyledCard, StyledHeader, StyledLogo } from './PostCard'
import styled from 'styled-components'
import TypographySecondary from 'components/Typography/Secondary'

type TwitterCardProps = {
    user: {
        url: string
        name: string
        username: string
    }
    text: string
    media: { media_url: string; type: string }[]
    url: string
}

const TwitterCard = ({ user, text, media, url }: TwitterCardProps) => {
    return (
        <StyledCard onClick={() => window.open(url, '_blank')}>
            <StyledHeader>
                <StyledLogo src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqTDCEsvutyTcwyKh0R7p4a2JJ8GyjNqi7BA&s' />
                <StyledTypographyWrapper onClick={() => window.open('https://x.com/', '_blank')}>
                    <TypographyPrimary value='Twitter' bold />
                </StyledTypographyWrapper>

                <StyledTypography onClick={() => window.open(user.url, '_blank')}>
                    {`@${user.username}`}
                </StyledTypography>
            </StyledHeader>

            <StyledBody>
                <TypographySecondary value={text} size='medium' />

                <StyledMediaContainer>
                    {media.map((image, index) => {
                        return <StyledImg key={index} src={image.media_url} />
                    })}
                </StyledMediaContainer>
            </StyledBody>
        </StyledCard>
    )
}

export default TwitterCard

const StyledImg = styled.img`
    max-height: 200px;
    max-width: 300px;
    width: 100%;

    object-fit: cover;
`
const StyledTypography = styled.span`
    color: ${({ theme }) => theme.body.linkTextColor} !important;
    font-size: 14px;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
        text-decoration: underline;
    }
`
export const StyledTypographyWrapper = styled.div`
    &:hover {
        opacity: 0.8;
    }
`
const StyledMediaContainer = styled.div`
    display: flex;
    gap: 2px;
`
